export enum ReportContentCategoryState {
  Active = 'Active',
  Inactive = 'Inactive'
}
